webinar = {
    host: '/',
    token : '',
    register: function () {
        if($("#inputPhoneNumberRegWeb").length){
            var inputPhoneNumberReg = document.querySelector("#inputPhoneNumberRegWeb");
            var countryCode = $("#inputPhoneNumberRegWeb").data('country');
            if(countryCode=='') {
                countryCode = 'pe';
            }
            var intPhoneNumberReg = intlTelInput(inputPhoneNumberReg, {
                initialCountry: countryCode,
                //utilsScript: main.host + "dist/js/utils.js",
                utilsScript: "https://intl-tel-input.com/node_modules/intl-tel-input/build/js/utils.js?1549804213570",
                preferredCountries: ['pe', 'co', 'mx','ar', 'es', 'us'],
                placeholderNumberType: "MOBILE",
                separateDialCode: true
            });
        }

        $('#country').on('change', function() {
            var countryId = this.value;
            intPhoneNumberReg.setCountry(countryId);
        });

        $("#form-register-webinar").validate({
            // Specify the validation rules
            ignore: ":hidden:not(.select-text-c)",
            rules: {
                timefech: { required: true },
                name: { required: true },
                lastName: { required: true },
                email: { required: true },
                country: { required: true },
                phone: { required: true },
            },
            messages:{
                timefech: { required: "Seleccione una Fecha" },
                name: { required: "Por favor ingrese su Nombre" },
                timefech: { required: "Por favor ingrese su Nombre" },
                lastName: { required: "Por favor ingrese su Apellido"  },
                email: { required: "Por favor ingrese su Email" },
                country: {  required: "Por favor Reingrese su Pais" },
                phone: { required: "Por favor ingrese su Télefono" },
            },
            errorPlacement: function(error, element) {
                error.insertBefore($(element).parents('.form-field__control').find('.error-cnt').html(error));
            },
            highlight: function(element) {
                $(element).parent('div').addClass("error-n");
            },
            unhighlight: function(element) {
                $(element).parent('div').removeClass("error-n");
            },
            submitHandler: function (form) {
                $("#form-register-webinar").find(".btn-l-primary").addClass("block-btn-load");
                $('#form-register-webinar .btn-l-primary').prop('disabled', true);
                $('#form-register-webinar .btn-l-primary').html('Cargando...');
                var params = { 
                    "name" : $('#name').val(),
                    "lastNme" : $('#lastName').val(),
                    "email" : $('#email').val(),
                    "quotesId" : $('#calendar').val(),
                    "phone" : $('#form-register-webinar .selected-dial-code').text() 
                        ? $('#form-register-webinar .selected-dial-code').text() + '-' + $('#inputPhoneNumberReg').val() : '' ,
                    "timezone": $('#timezone').val(),
                  };
            
                  $.ajax({
                    url:  webinar.host + 'es/api-client/quotes-reservation',
                    data: JSON.stringify(params),
                    type: 'POST',
                    dataType: "json",
                    headers: {
                        "Authorization": webinar.token,
                        "Content-Type": "application/json"
                    },
                    success : function(data) {
                        if (data.success == true) {
                            windowParent.postMessage({
                                'func': 'redirect',
                                'hash': webinarHash,
                                'url' : data.data.zoomUri
                            }, '*');

                        } else {
                            Swal.fire({
                                type: 'error',
                                title: 'Oops...',
                                text: data.message,
                            });
                            $("#form-register-webinar").find(".btn-l-primary").removeClass("block-btn-load");
                            $('#form-register-webinar .btn-l-primary').prop('disabled', true);
                            $('#form-register-webinar .btn-l-primary').html('Resgistrarme <i class="fas fa-chevron-right"></i>');
                        }
                    },
                    error : function(xhr, status) {
                        Swal.fire({
                            type: 'error',
                            title: 'Oops...',
                            text: 'Se produjo un error, intentalo en unos minutos.',
                          })
                    }
                });
                return false;
            }
        });
    },
    updateTimezone: function() {
        $('.select-text-c').prop('disabled', false);
        $('.select-text-c').selectpicker('refresh');
    },
    selectTimezone: function() {
        $( "#timezone" ).change(function() {
            var id = $('#publicationId').val();
            var idSelected = $('#calendar').val();
            var timezone = $(this).val();
            $.ajax({
                url : '/es/webinar/timezone', 
                type : 'GET',
                dataType : 'json',
                data : {id: id, timezone: timezone, idSelected: idSelected},
                success : function(data) {
                    if(data.success) {
                        var option = ''; 
                        $.each(data.data, function(index, value) {
                            if(value.id == data.idSelected){
                                option += '<option seleted value="'+value.id+'*'+value.date+'" data-subtext="'+value.countDown+'">'+value.name+'</option>';
                            } else {
                                option += '<option value="'+value.id+'*'+value.date+'" data-subtext="'+value.countDown+'">'+value.name+'</option>';
                            }
                        })
                        $('#calendar').html(option); 
                        setTimeout(function(){ $('#calendar').selectpicker('refresh'); }, 200);
                    } 
                }  
            });
        });
        
    }
}
